import React, { useEffect, useState } from "react";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import { Box, Typography, List, ListItem, ListItemText } from "@mui/material";
import Cars from "../../cars/Cars";
import axios from "axios";
import { url } from "../../../utils/url";
import { calculateMonthPrice, monthDataDisplay } from "../../../utils/functions";
import { monthData } from "../../../utils/table";
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';

const MonthlyReport = () => {
  const [date, setDate] = useState(dayjs(new Date()));
  const [carId, setCarId] = useState("");
  const [travelMonth, setTravelMonth] = useState([]);
  const [emptyMonth, setEmptyMonth] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const startOfMonth = date.clone().startOf("month").format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
    const endOfMonth = date.clone().endOf("month").format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
  
    setEmptyMonth(false);
    setError(null);
    setTravelMonth([]);
    if (!carId) {
      return;
    }
    
    (async () => {
      try {
        const monthRequest = await axios.get(`${url}travels/${startOfMonth}?toDate=${endOfMonth}&vehicleId=${carId}`, { withCredentials: true });
 
        if (monthRequest.data.length < 1) {
          setEmptyMonth(true);
          return;
        }
        const parsing = monthRequest.data.map((el) => JSON.parse(el.data));
        const calculateMonthPriceFunction = calculateMonthPrice(parsing);
        const month = monthDataDisplay(monthData, calculateMonthPriceFunction);
        setTravelMonth(month);
      } catch (err) {
        setError("Възникна проблем! Моля опитайте по-късно");
        console.log(err);
      }
    })();
  }, [date, carId]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "30px",
      }}
    >
      <Cars setCarId={setCarId} />
      <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DateCalendar']}>
        <DemoItem>
          <DateCalendar
            defaultValue={date}
            views={['month', 'year']}
            openTo="month"
            value={date} onChange={(value) => setDate(() => value)}
          />
        </DemoItem>
      </DemoContainer>
    </LocalizationProvider>
      {error && <Typography color="red">{error}</Typography>}
      {emptyMonth ? (
        <Typography>Няма информация за тoзи месец</Typography>
      ) : (
        travelMonth.length > 0 && (
          <List
            component="nav"
            sx={{
              width: "100%",
              maxWidth: 360,
              bgcolor: "background.paper",
              border: "1px solid rgba(0, 0, 0, 0.12)",
            }}
          >
            {travelMonth.map((el) => (
              <ListItem key={el.valueName} divider={el !== travelMonth[travelMonth.length - 1] ? true : false}>
                <ListItemText primary={el.valueName} />
                <Typography>{el.value}</Typography>
              </ListItem>
            ))}
          </List>
        )
      )}
    </Box>
  );
};

export default MonthlyReport;
